import { ButtonCollapsible } from '@bgea-js/design-library';
import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import MainContentMay25 from "../../../../src/content/prayer-letter-may-2025/main-content-may25.md";
import LearnMoreMay25 from "../../../../src/content/prayer-letter-may-2025/learn-more-details-may25.md";
import "../../../../src/content/prayer-letter-may-2025/prayer-letter-may.scss";
import * as React from 'react';
export default {
  ButtonCollapsible,
  SingleDonationForm,
  MainContentMay25,
  LearnMoreMay25,
  React
};